import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/my-documents')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' })
  },
})
